import React, { useState, useEffect } from "react";
import Styled from "./DrawerStyles";

import { ColorSAP, FONT_FAMILY, Typography } from "../../ontego-ui";
import { useTranslation } from "react-i18next";
import { F_SONDERFUNKTIONEN_ERWEITERUNGEN } from "../../Constants/FunctionIds";
import Tooltip from "../Tooltip/Tooltip";

export const Drawer = (props) => {
  const [activeMenu, setActiveMenu] = useState({});
  const [firstLoad, setFirstLoad] = useState(true);

  const { t } = useTranslation();

  const {
    id,
    activeOption,
    isProcessTypeAlreadyAddedToCollection,
    collection,
    menus,
    isScrolling,
    setIsScrolling,
    setAppPreviewNavIndex,
    style,
    toolTipTitle,
    inspectedFunctionId,
    search,
  } = props;

  useEffect(() => {
    if (search) return;
    if (activeOption !== `` && !isScrolling) {
      menus.forEach((menu) => {
        if (menu.name === activeOption) {
          setActiveMenu(menu);
          if (!firstLoad) {
            setAppPreviewNavIndex(0);
          }
        }
      });
    }

    setFirstLoad(false);
  }, [activeOption]);

  // Clear active menu when searching
  useEffect(() => {
    if (search) {
      setActiveMenu({});
    }
  }, [search]);

  // to anchor scroll
  useEffect(() => {
    if (search) return;
    if (menus) {
      let lastMenu = null;
      const hash = window.location.hash;

      var hashName = hash.substring(6);

      if (hashName !== "") {
        menus.forEach((eachElement) => {
          if (eachElement.name === hashName) {
            lastMenu = eachElement;
          }
        });
        setTimeout(() => {
          const element = document.getElementById(lastMenu?.name);

          element?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });

          if (lastMenu) {
            setActiveMenu(lastMenu);
          }
        }, 500);
      }
    }
  }, [menus]);

  const handleMenuOnClick = (menu) => () => {
    setIsScrolling(true);
    setActiveMenu(menu);
    setAppPreviewNavIndex(0);

    let selectedIndex = 0;
    menus.forEach((eachElement, index) => {
      if (eachElement.name === menu.name) selectedIndex = index;
    });
    const sectionHash = `#menu#${menu.name}`;
    window.location.hash = sectionHash;
    let lastMenu = null;
    menus.forEach((eachElement, index) => {
      if (parseInt(index) === parseInt(selectedIndex)) lastMenu = eachElement;
    });
    setTimeout(() => {
      const element = document.getElementById(lastMenu?.name);
      element?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          ...style,
        }}
        id={id}
      >
        {menus.map((menu, index) => (
          <Styled.DrawerMenu id={`menu${index}`} key={`menu${index}`}>
            {menu.name !== "" && (
              <>
                <a style={{ textDecoration: "none" }}>
                  <Styled.DrawerMenuLabel onClick={handleMenuOnClick(menu)}>
                    <Typography
                      fontFamily={
                        menu.name === activeMenu.name
                          ? FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD_ITALIC
                          : FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM
                      }
                      size={16}
                      color={
                        menu.name === activeMenu.name
                          ? ColorSAP.primary[70]
                          : ColorSAP.neutral[100]
                      }
                    >
                      {inspectedFunctionId === F_SONDERFUNKTIONEN_ERWEITERUNGEN
                        ? menu.name
                        : (menu.dataType &&
                            menu.dataType[0] &&
                            menu.dataType[0].title) ||
                          ""}
                    </Typography>
                  </Styled.DrawerMenuLabel>
                </a>
                {/* Yellow dot indicator for collection - commented out
                                {isProcessTypeAlreadyAddedToCollection(collection, menu) && (
                                    <Tooltip title={toolTipTitle || "Added to Collection"} placement="right">
                                        <Styled.DrawerMenuIsCustomizedTag />
                                    </Tooltip>
                                )}
                                */}
              </>
            )}
          </Styled.DrawerMenu>
        ))}
      </div>
      <a id="link-drawer" style={{ visibility: "hidden" }} />
    </>
  );
};

export default React.memo(Drawer);
